
/*
 *
 * Date: 2025
 * Description: Question form component for adding a question to the database.
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { ReactElement } from "react"
import { Box , Button, Grid, TextField, Typography} from "@mui/material"
import { i_modal_form_props } from "../../interfaces/utility.interface"



const QuestionForm = ( props : i_modal_form_props ) : ReactElement => {
    const F = props.form
    const E = props.errors
    const handleField = ( event : React.ChangeEvent<HTMLInputElement> ) => {
        const { name, value } = event.target
        props.setForm({...F, [name] : value})
    }
    return (
        <Box>
            <Grid container>
                <Grid size={3} sx={{ alignItems : 'center' , alignContent : 'center'}}>
                    <Typography variant={"h6"}>Subject:</Typography>
                </Grid>
                <Grid size={9}>
                    <TextField name={"subject"} value={F.subject} onChange={handleField} error={E.subject!== ''? true : false} helperText={E.subject} fullWidth/>
                </Grid>
                <Grid size={12} sx={{ marginTop : '2vh'}}>
                    <Typography variant={"h6"}>Message:</Typography>
                </Grid>
                <Grid size={12}>
                    <TextField multiline rows={4} name={"message"} value={F.message} onChange={handleField} error={E.message!== ''? true : false} helperText={E.message} fullWidth/>
                </Grid>
                <Grid size={12} sx={{ marginTop : '1vh'}}>
                    <Button variant={"contained"} sx={{ marginLeft : 'auto' , marginRight : 'auto' , display : 'block', fontSize : 20}} color={"primary"} onClick={() => props.callback()}>Submit</Button>
                </Grid>
            </Grid>
        </Box>
    )
}

export default QuestionForm